// extracted by mini-css-extract-plugin
export default {"container":"aoZZ0y","title":"iFr3QJ","text":"OZx5uo"};